import type { InjectionKey } from 'vue'

export const STORAGE_UPLOAD_PATH = '/api/saas/storage/upload'
export const MAX_DECORATION_UPLOAD_BYTES = 10 * 1024 * 1024

export const DECORATION_UPLOAD_IMAGE_KEY: InjectionKey<(file: File, options?: { signal?: AbortSignal }) => Promise<string>> =
  Symbol('renDecorationUploadImage')

export function extractStorageUploadUrl(payload: unknown): string {
  if (!payload || typeof payload !== 'object') return ''
  const row = payload as Record<string, unknown>
  const nested = row.data && typeof row.data === 'object' ? (row.data as Record<string, unknown>) : row
  const raw = nested.url ?? nested.objectKey ?? row.url ?? row.objectKey ?? ''
  return typeof raw === 'string' ? raw.trim() : ''
}

function readSaasBearerToken(): string {
  if (typeof localStorage === 'undefined') return ''
  try {
    const raw = localStorage.getItem('xjlv2:saas-session')
    if (!raw) return ''
    const session = JSON.parse(raw) as { token?: string }
    return typeof session.token === 'string' ? session.token : ''
  } catch {
    return ''
  }
}

export async function uploadSaasStorageImage(
  file: File,
  options: { moduleCode?: string; category?: string; token?: string; signal?: AbortSignal } = {}
): Promise<string> {
  if (file.size > MAX_DECORATION_UPLOAD_BYTES) {
    throw new Error('图片大小不能超过 10MB')
  }
  const params = new URLSearchParams()
  params.set('moduleCode', options.moduleCode?.trim() || 'decoration')
  params.set('category', options.category?.trim() || 'decoration')
  const form = new FormData()
  form.append('file', file)
  const token = options.token || readSaasBearerToken()
  const response = await fetch(`${STORAGE_UPLOAD_PATH}?${params.toString()}`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
    signal: options.signal
  })
  const payload = (await response.json().catch(() => null)) as Record<string, unknown> | null
  if (response.status === 413) {
    throw new Error('上传失败：文件过大被网关拦截（限制 10MB）')
  }
  if (!response.ok || payload?.success === false) {
    const message = payload?.message || payload?.msg
    throw new Error(typeof message === 'string' && message ? message : `上传失败 (${response.status})`)
  }
  const url = extractStorageUploadUrl(payload)
  if (!url) throw new Error('上传成功但未返回图片地址')
  return url
}
